module.exports = __webpack_public_path__ + "static/img/tuijiandefault.4be6b74d.png";